<script setup>

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
    <path d="M4.5625 0.5V3.75M11.0625 0.5V3.75M0.5 7H15.125M4.5625 10.25H4.57063M7.8125 10.25H7.82063M11.0625 10.25H11.0706M4.5625 13.5H4.57063M7.8125 13.5H7.82063M11.0625 13.5H11.0706M2.125 2.125H13.5C14.3975 2.125 15.125 2.85254 15.125 3.75V15.125C15.125 16.0225 14.3975 16.75 13.5 16.75H2.125C1.22754 16.75 0.5 16.0225 0.5 15.125V3.75C0.5 2.85254 1.22754 2.125 2.125 2.125Z" stroke="#364C3A" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped lang="scss">

</style>